import { Header, Text } from '@rbilabs/universal-components';
import { Image } from 'expo-image';
import { useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import ActionButton from 'components/action-button';
import Link from 'components/link';
import { useAuthContext } from 'state/auth';
import { primitive } from 'styles/constants/primitives';
import { region } from 'utils/environment';
import { Region } from 'utils/environment/types';
import { routes } from 'utils/routing';

import { Perks } from './perks';

const openLinkIcon = require('./open-link-icon.svg');

export const UnauthenticatedProfile = () => {
  const { openSignInModal } = useAuthContext();
  const { formatMessage } = useIntl();

  const ctaLabel = formatMessage({ id: 'signInUp', defaultMessage: 'Sign Up / Sign In' });
  const isCanada = region === Region.CA;

  return (
    <View style={styles.mainContainer}>
      <Header style={styles.header}>
        {formatMessage({
          id: 'loyaltyProfileMeetTheProgram',
          defaultMessage: 'Meet Royal Perks Rewards',
        })}
      </Header>
      <Perks />
      <View style={styles.footer}>
        <Text variant="copyOne" textAlign="center">
          {formatMessage({
            id: 'loyaltyProfileJoinTheProgram',
            defaultMessage: 'Join the program and start earning crowns and redeem rewards.',
          })}
        </Text>
        <ActionButton
          fullWidth
          accessibilityLabel={ctaLabel}
          accessibilityRole="button"
          onPress={() => openSignInModal()}
        >
          {ctaLabel}
        </ActionButton>
        <Link to={isCanada ? routes.bkRewards : routes.royalPerks} style={styles.learnMoreLink}>
          <Text style={styles.learnMoreLinkText} fontFamily="heading">
            {formatMessage({
              id: 'loyaltyProfileLearnMore',
              defaultMessage: 'More About Royal Perks',
            })}
          </Text>
          <Image source={openLinkIcon} style={styles.openLinkIcon} />
        </Link>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    alignItems: 'stretch',
    paddingVertical: primitive.spacing.$6,
    paddingHorizontal: primitive.spacing.$4,
    gap: primitive.spacing.$4,
  },
  header: {
    marginBottom: primitive.spacing.$2,
    textAlign: 'center',
    lineHeight: primitive.fontSizes['3xl'],
  },
  footer: {
    alignItems: 'center',
    gap: primitive.spacing.$3,
  },
  learnMoreLink: {
    alignItems: 'flex-end',
    gap: primitive.spacing.$1,
    margin: primitive.spacing.$2,
  },
  learnMoreLinkText: {
    fontSize: primitive.fontSizes.xs,
    alignItems: 'center',
    display: 'flex',
    lineHeight: primitive.fontSizes.sm,
  },
  openLinkIcon: {
    width: 10,
    height: 10,
    marginBottom: 1,
  },
});
